export const marginlyPoolWethUsdcPolygonMumbai = {
  address: "0x46C1f8Ab01872CB09c35063A980e7D87E79A884b",
};
